import React from 'react';
import LayoutProvider from '../../../Contexts/LayoutProvider';
import LibModal from '../../../features/LibModal/LibModal';
import PageTitle from '../../../utils/PageTitle';
import ServiceListBody from './Components/ServiceListBody';
import ServiceListBodyMobile from './Components/ServiceListBodyMobile';
import ServiceListHeader from './Components/ServiceListHeader';
import AddServiceModal from './Modals/AddServiceModal';
import ServicesProvider, { useServices } from './ServicesProvider';

function PageCont() {
    const { addServiceModal, setAddServiceModal, services, servicesFilter } = useServices();

    const searchValue = servicesFilter?.searchValue || '';
    const status = servicesFilter?.status || '';

    // filter services by searchValue
    const data =
        services
            ?.filter((item) => {
                if (searchValue?.length) {
                    return item?.applicationTitle
                        ?.toLowerCase()
                        .includes(searchValue?.toLowerCase());
                }
                return [];
            })
            ?.filter((item) => {
                if (status?.length) {
                    return item?.status === status;
                }
                return [];
            }) || services;

    return (
        <div className="services-setting inner_page_cont pb-40">
            <ServiceListHeader />

            <LayoutProvider>
                <ServiceListBody layout="default" data={data} />
                <ServiceListBodyMobile layout={['md', 'sm', 'xs', 'xxs']} data={data} />
            </LayoutProvider>

            {addServiceModal && (
                <LibModal title="Add Service" setOpen={setAddServiceModal}>
                    <AddServiceModal setAddServiceModal={setAddServiceModal} />
                </LibModal>
            )}
        </div>
    );
}

function ServicesPage() {
    // set page title
    PageTitle(`Services`);

    return (
        <ServicesProvider>
            <PageCont />
        </ServicesProvider>
    );
}

export default ServicesPage;
